import React from 'react'
import GenerateManualEventAttendenceCertificateForm from '../../features/GenerateManualEventAttendenceCertificate/generateManualEventAttendenceCertificateForm'

const GenerateManualEventAttendenceCertificate = () => {
    return (
        <GenerateManualEventAttendenceCertificateForm />
    )
}

export default GenerateManualEventAttendenceCertificate
